// extracted by mini-css-extract-plugin
module.exports = {"layout":"CasesLayout_layout__1o7h8","cases":"CasesLayout_cases__3i21N","case":"CasesLayout_case__2DM5T","active":"CasesLayout_active__SHdi2"};